<template>
  <div class="l-bubbles-box">
    <section class="l-bubbles-section l-bubble-l-section">
      <div class="l-fly-bubbles"
           v-for="(item,index) in bubbles"
           :key="index"
           :class="'bubbles'+index"
           :style="{'left':(item*9)/100+'rem','bottom':(-index*22)/100+'rem'}"><span :style="{'width':((index+1)*4.5)/100+'rem','height':((index+1)*4.5)/100+'rem'}"></span></div>
    </section>
    <section class="l-bubbles-section l-bubble-r-section">
      <div class="l-fly-bubbles"
           v-for="(item,index) in bubbles"
           :key="index"
           :class="'bubbles'+index"
           :style="{'left':(item*9)/100+'rem','bottom':(-index*22)/100+'rem'}"><span :style="{'width':((index+1)*4.8)/100+'rem','height':((index+1)*4.8)/100+'rem'}"></span></div>
    </section>
  </div>
</template>

<script>
export default {
  name: "l-bubbles",
  data() {
    return {
      bubbles: [2, 9, 20, 14, 5, -3, -10, -9, -13, 8], //10
    };
  },
};
</script>

<style scoped>
.l-bubbles-box {
  position: fixed;
  z-index: 5;
}
.l-bubbles-section {
  width: 200px;
  height: 100%;
  position: fixed;
}
/* 动效---常规运动--X方向 */
@keyframes ballMoveX {
  0% {
    transform: translateX(0);
  }
  16% {
    transform: translateX(-50px);
  }
  33% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-30px);
  }
  100% {
    transform: translateX(0);
  }
}
/* 动效--减小左右移动的幅度 */
@keyframes ballMoveX2 {
  0% {
    transform: translateX(0);
  }
  16% {
    transform: translateX(-20px);
  }
  33% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-20px);
  }
  100% {
    transform: translateX(0);
  }
}
/* 相反方向 */
@keyframes ballMoveX3 {
  0% {
    transform: translateX(0);
  }
  16% {
    transform: translateX(50px);
  }
  33% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(25px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes ballMoveX4 {
  0% {
    transform: translateX(0);
  }
  16% {
    transform: translateX(20px);
  }
  33% {
    transform: translateX(40px);
  }
  50% {
    transform: translateX(60px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes ballMoveX5 {
  0% {
    transform: translateX(0);
  }
  16% {
    transform: translateX(-35px);
  }
  33% {
    transform: translateX(-45px);
  }
  52% {
    transform: translateX(-80px);
  }
  100% {
    transform: translateX(0);
  }
}
/* 动效---常规运动--Y方向 */
@keyframes ballMoveY {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    transform: translateY(-111vh);
    opacity: 1;
  }
  51% {
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 0;
  }
}

.l-fly-bubbles > span {
  background: url(../images/dot/bubble.png) no-repeat;
  background-size: 100% 100%;
}

.l-fly-bubbles,
.l-fly-bubbles > span {
  position: absolute;
  bottom: 0;
  left: 200px;
  width: 30px;
  height: 30px;
}
.l-fly-bubbles {
  animation: ballMoveX 4.5s cubic-bezier(0.3, 0.27, 0.07, 1.64) infinite;
}
.l-fly-bubbles > span {
  animation: ballMoveY 4.5s linear infinite;
}

.bubbles1 {
  animation-delay: 1s;
}

.bubbles1 > span {
  animation-delay: 1s;
}
.bubbles2 {
  animation: ballMoveX2 4.5s 0.15s linear infinite;
}
.bubbles3 {
  animation: ballMoveX3 4.5s 0.15s cubic-bezier(0.55, 0, 0.85, 0.36) infinite;
}
.bubbles4 {
  animation: none;
}
.bubbles4 > span {
  animation-duration: 4.45s;
}
.bubbles5 {
  animation: ballMoveX3 4.5s 0.1s cubic-bezier(0.3, 0.27, 0.07, 1.64) infinite;
}

.bubbles6,
.bubbles7 {
  animation: ballMoveX4 4.5s 0s linear infinite;
}
.bubbles7 {
  animation-duration: 3.6s;
}

.bubbles8 {
  animation: ballMoveX5 4.5s 0.1s cubic-bezier(0.3, 0.27, 0.07, 1.64) infinite;
}

.bubbles9 {
  animation-delay: 0.2s;
}

/* 右侧气泡组 */
.l-bubble-r-section {
  right: 0;
  transform: perspective(0) rotateY(180deg);
}
.l-bubble-r-section .l-fly-bubbles > span {
  animation-delay: 1s;
  background: url(../images/dot/bubbleRight.png) no-repeat;
  background-size: 100% 100%;
}
.l-bubble-r-section .l-fly-bubbles {
  animation-duration: 7s;
}
</style>
